import { Box, CircularProgress } from '@mui/material'
import { useEffect, useState } from 'react'
import EmoteIcon from '../../../assets/icons/emotes/emote.svg?react'
import { useStoreActions, useStoreState } from '../../../store/hooks'
import CircularButton from '../../analysisView/components/analyisControls/CircularButton'
import { ControlSlot } from '../components/gameEndControls/ControlSlot'
import { selectEmoteSlot } from './EmotesModel'

// Share of the send cooldown still left (1 → 0); 0 when no cooldown runs.
export const useEmoteCooldown = () => {
    const cooldownUntil = useStoreState((state) => state.emotes.cooldownUntil)
    const cooldownTotal = useStoreState((state) => state.emotes.cooldownTotal)
    const [now, setNow] = useState(Date.now())

    useEffect(() => {
        setNow(Date.now())
        if (cooldownUntil <= Date.now()) return
        const tick = setInterval(() => setNow(Date.now()), 100)
        const end = setTimeout(() => {
            clearInterval(tick)
            setNow(Date.now())
        }, cooldownUntil - Date.now())
        return () => {
            clearInterval(tick)
            clearTimeout(end)
        }
    }, [cooldownUntil])

    const left = Math.max(0, cooldownUntil - now)
    return cooldownTotal > 0 ? Math.min(1, left / cooldownTotal) : 0
}

type Props = {
    disabled?: boolean
    gutter?: string
    delay?: number
}

export const EmoteButton = ({ disabled, gutter, delay }: Props) => {
    const slot = useStoreState(selectEmoteSlot)
    const cooldown = useEmoteCooldown()
    const openPicker = useStoreActions((actions) => actions.emotes.openPicker)

    return (
        <ControlSlot show={slot !== 'hidden'} gutter={gutter} delay={delay}>
            <Box style={{ position: 'relative' }}>
                {cooldown > 0 && (
                    <CircularProgress
                        variant="determinate"
                        value={cooldown * 100}
                        size="40px"
                        style={{ position: 'absolute', top: 0, left: 0, zIndex: 4, pointerEvents: 'none' }}
                    />
                )}
                <CircularButton
                    title="Emote"
                    disabled={disabled || slot !== 'ready'}
                    onClick={() => openPicker()}
                    icon={<EmoteIcon style={{ transform: 'translateY(1.7px)' }} />}
                />
            </Box>
        </ControlSlot>
    )
}
